import { ExclamationMarkIcon } from "@/components/Icons/ExclamationMarkIcon";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { useHandleError } from "@/hooks/useHandleError";
import { useRedeemCoupon } from "@roman/shared/hooks/coupon/useRedeemCoupon";
import { useAuthStore } from "@roman/shared/store/auth.store";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { CouponSuccessModal } from "./CouponSuccessModal";
import RedeemedCoupons from "./RedeemedCoupons";

export const CouponRedeemPage = () => {
  const fetchUser = useAuthStore((state) => state.fetchAndSetUser);
  const [couponCode, setCouponCode] = useState<string>("");
  const navigate = useNavigate();
  const [couponErrorMessage, setCouponErrorMessage] = useState<string | null>(null);

  const {
    trigger: redeemCoupon,
    isMutating,
    data: redeemedCouponCode,
  } = useRedeemCoupon(useHandleError, () => {
    setCouponErrorMessage("無効なクーポンコードです。");
  });
  const [openSuccessDialog, setOpenSuccessDialog] = useState(false);

  const handleCodeChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setCouponCode(e.currentTarget.value);
  };

  const onSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    if (couponCode && !isMutating) {
      await redeemCoupon(
        { code: couponCode },
        {
          onSuccess: async () => {
            setOpenSuccessDialog(true);
          },
        },
      );
    }
  };

  return (
    <>
      <div className="min-h-screen w-full max-w-3xl p-4 lg:p-8 bg-white">
        {
          <div className="flex flex-col items-start gap-10 w-full">
            <div className="px-1">
              <p className="font-semibold text-xl text-black">クーポンの登録</p>
            </div>

            <form onSubmit={onSubmit} className="flex flex-col items-center gap-1 w-full px-5">
              <div className="grid w-full items-center gap-1.5 max-w-[500px] ">
                <Label htmlFor="couponCode" className="text-lg">
                  クーポンコード
                </Label>
                <Input
                  id="couponCode"
                  name="couponCode"
                  className="border border-solid border-disabled px-5 py-2.5 font-normal text-base rounded-md w-full focus-visible:ring-0 h-[50px]"
                  placeholder="クーポンコードを入力"
                  onChange={handleCodeChange}
                />
              </div>
              {couponErrorMessage && (
                <div className="flex items-start w-full gap-1 max-w-[500px] ">
                  <ExclamationMarkIcon />
                  <p className="text-sm text-red">{couponErrorMessage}</p>
                </div>
              )}
              <Button
                variant="default"
                className="w-full mt-5 text-white disabled:bg-disabled h-[50px] text-base max-w-[500px] "
                disabled={!couponCode}
              >
                保存する
              </Button>
            </form>
          </div>
        }

        <div className="mt-11">
          <RedeemedCoupons />
        </div>
      </div>

      {redeemedCouponCode && (
        <CouponSuccessModal
          open={openSuccessDialog}
          setOpen={(open: boolean) => {
            if (!open) {
              navigate("/");
              setOpenSuccessDialog(false);
              fetchUser();
            }
            setOpenSuccessDialog(open);
          }}
          earnedPoints={redeemedCouponCode.reward.amount}
        />
      )}
    </>
  );
};
